export default "__VITE_PUBLIC_ASSET__1ac2c5ec__"